// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_a8-0";
export var orangeButton = "_a8-1";